<template>
  <div class="edit-studio-container">
    <main class="tab-content">
      <h2 class="item text-secondary">Startup phase content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Introduction1:</label>
          <textarea type="text" class="form-control" v-model="fit20.blockToEdit.introduction1"></textarea>
        </div>
        <div class="field-sec">
          <label>Introduction2:</label>
          <textarea type="text" class="form-control" v-model="fit20.blockToEdit.introduction2"></textarea>
        </div>
        <div class="field-sec">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.title_top" />
        </div>
        <div class="field-sec">
          <label>Bottom text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.title_bottom" />
        </div>
        <div class="field-sec">
          <label class="">Country:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.country" />
        </div>
        <div class="field-sec steps">
          <label class="">Steps:</label>
          <section class="flex">
            <div v-for="item, i in fit20.blockToEdit.steps" :data-step="i + 1">
              <textarea type="text" class="form-control" v-model="fit20.blockToEdit.steps[i]"></textarea>
            </div>
          </section>
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div class="steps-container">
        <h2 id="title_top">{{ fit20.blockToEdit.title_top }}</h2>
        <div class="font-uk" id="introduction1" v-if="fit20.blockToEdit.introduction1">{{
          fit20.blockToEdit.introduction1 }}</div>
        <div class="font-uk" id="introduction2" v-if="fit20.blockToEdit.introduction2">{{
          fit20.blockToEdit.introduction2 }}</div>

        <ul class="StepProgress" id="steps_container">
          <div class="steps-row" v-for="step, index in fit20.blockToEdit.steps.filter(steps => steps.length > 0)">
            <div class="steps-row-item empty" v-if="index % 2 != 0"></div>
            <div v-if="index % 2 == 0" :class="['steps-row-item',
              fit20.blockToEdit.country == 'uk' ? 'font-uk' : ''
            ]" v-html="step"></div>
            <li :class="['StepProgress-item', 'current', 'steps-row-item2',
              'item' + (index + 1),
              index + 1 != fit20.blockToEdit.steps.length ? 'not-last' : 'last'
            ]"></li>
            <div v-if="index % 2 != 0" :class="['steps-row-item',
              fit20.blockToEdit.country == 'uk' ? 'font-uk' : ''
            ]" v-html="step"></div>
            <div class="steps-row-item empty" v-if="index % 2 == 0"></div>
          </div>
        </ul>
        <h2 id="title_bottom">{{ fit20.blockToEdit.title_bottom }}</h2>
      </div>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>

  </div>
</template>

<script>
export default {
  name: 'StartupPhase',
  props: ["fit20", "saveBlock", "cancelEditing"],
};
</script>

<style scoped>
.steps {
  width: 100% !important;
}

.steps div {
  width: 45% !important;
  margin-left: 20px;
  margin-top: 5px;
  position: relative;

}

.steps div::before {
  content: attr(data-step);
  color: black;
  position: absolute;
  left: -17px;

}

.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* example css */
.steps-container {
  background-color: #009fe31f;
  margin: 0 auto;
  padding: 40px 60px;
  max-width: 1500px;
}

.steps-container h2 {
  text-align: center;
  color: #009fe3;
}

.StepProgress {
  position: relative;
  list-style: none;
  padding: 45px 0px;
}

.StepProgress-item {
  position: relative;
}

.StepProgress-item:not(:last-child) {
  padding-bottom: 20px;
}

.StepProgress-item::before {
  display: inline-block;
  content: '';
  position: absolute;
  left: 23px;
  height: 100%;
  width: 10px;
}

.StepProgress-item::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  width: 12px;
  height: 12px;
  border: 2px solid #ccc;
  border-radius: 50%;
  background-color: #fff;
}

.StepProgress-item.current:not(.last):before {
  border-left: 3px solid #009fe3;
}

.StepProgress-item.item1::after {
  content: '1';
}

.StepProgress-item.item2::after {
  content: '2';
}

.StepProgress-item.item3::after {
  content: '3';
}

.StepProgress-item.item4::after {
  content: '4';
}

.StepProgress-item.item5::after {
  content: '5';
}

.StepProgress-item.item6::after {
  content: '6';
}

.StepProgress-item.item7::after {
  content: '7';
}

.StepProgress-item.item8::after {
  content: '8';
}

.StepProgress-item.item9::after {
  content: '9';
}

.StepProgress-item.item10::after {
  content: '10';
}

.StepProgress-item.item11::after {
  content: '11';
}

.StepProgress-item.item12::after {
  content: '12';
}

.StepProgress-item.item13::after {
  content: '13';
}

.StepProgress-item.item14::after {
  content: '14';
}

.StepProgress-item.item15::after {
  content: '15';
}

.StepProgress-item.current::after {
  width: 32px;
  height: 32px;
  left: 8px;
  font-size: 17px;
  text-align: center;
  color: white;
  border: 2px solid #009fe3;
  background-color: #009fe3;
}

.StepProgress strong {
  display: block;
}

.steps-row {
  width: 100%;
  max-height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.steps-row-item {
  width: 47%;
  max-width: 450px;
  text-align: center;
  padding: 20px 30px;
  border-radius: 10px;
  font-size: 23px !important;
  font-family: 'Open sans', Verdana, Geneva, Tahoma, sans-serif;
}

.font-uk {
  font-size: 19px !important;
  line-height: 20px !important;
  text-align: center;
}

.steps-row-item:not(.empty) {
  background-color: white;
}

.steps-row-item2 {
  width: 50px;
  height: 100px;
}

@media only screen and (max-width: 1100px) {
  .steps-container ul.StepProgress div.steps-row-item {
    padding: 20px 25px;
    font-size: 20px !important;
  }

  .steps-container ul.StepProgress div.steps-row-item.font-uk {
    font-size: 17px !important;
    line-height: 20px !important;
  }

  .font-uk {
    font-size: 17px !important;
  }
}

@media only screen and (max-width: 970px) {
  .steps-container {
    padding: 40px 50px;
  }

  .steps-container ul.StepProgress div.steps-row-item {
    margin-top: -50px;
    padding: 15px 20px;
    font-size: 18px !important;
  }

  .steps-container ul.StepProgress div.steps-row-item.font-uk {
    font-size: 16px !important;
  }

  .font-uk {
    font-size: 16px !important;
  }
}

@media only screen and (max-width: 850px) {
  .steps-container {
    padding: 40px 40px;
  }

  .steps-container ul.StepProgress div.steps-row-item {
    margin-top: -20px;
    padding: 15px 15px;
    font-size: 16px !important;
  }

  .steps-container ul.StepProgress div.steps-row-item2 {
    height: 70px;
  }
}

@media only screen and (max-width: 700px) {
  .StepProgress-item.current::after {
    padding-top: 2px !important;
    width: 25px;
    height: 25px;
    font-size: 12px;
  }

  .StepProgress-item::before {
    left: 19px;
  }

  .steps-container {
    padding: 20px 20px;
  }

  .steps-container ul.StepProgress div.steps-row-item {
    margin-top: 0px;
    padding: 15px 5px;
    font-size: 14px !important;
  }

  .steps-container ul.StepProgress div.steps-row-item2 {
    height: 60px;
  }
}

@media only screen and (max-width: 600px) {
  .steps-container {
    padding: 20px 10px;
  }

  .steps-container ul.StepProgress div.steps-row-item {
    font-size: 13px !important;
  }
}

@media only screen and (max-width: 600px) {
  .steps-container {
    padding: 20px 5px;
  }

  .steps-container ul.StepProgress div.steps-row-item {
    font-size: 11px !important;
  }

  .steps-container ul.StepProgress div.steps-row-item.font-uk {
    font-size: 11px !important;
    line-height: 15px !important;
  }

  .font-uk {
    font-size: 11px !important;
  }
}
</style>
